// StaticFieldEditor.js
import React, { useState } from 'react';

const StaticFieldEditor = ({ staticFields, onSave, onClose }) => {
  const [fields, setFields] = useState(staticFields);

  const handleEdit = (field, parent, index) => {
    if (Array.isArray(fields[parent])) {
      const newFields = { ...fields };
      newFields[parent][index] = field.value;
      setFields(newFields);
    }
  };

  const handleDelete = (parent, index) => {
    if (Array.isArray(fields[parent])) {
      const newFields = { ...fields };
      newFields[parent] = newFields[parent].filter((_, i) => i !== index);
      setFields(newFields);
    }
  };

  const handleSave = () => {
    onSave(fields);
    onClose();
  };

  return (
    <div className="page-modal">
      <div className="modal">
        <div className="modal-content">
          <h3>Edit Static Fields</h3>
          <div className="modal-scrollable">
            {Object.keys(fields).map((fieldName) => (
              <div key={fieldName}>
                <h4>{fieldName}</h4>
                <ul>
                  {fields[fieldName].map((value, index) => (
                    <li key={index}>
                      <input
                        type="text"
                        value={value}
                        onChange={(e) => handleEdit({ value: e.target.value }, fieldName, index)}
                      />
                      <button onClick={() => handleDelete(fieldName, index)}>Delete</button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="modal-buttons">
            <button onClick={handleSave}>Continue</button>
            <button onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticFieldEditor;
